module.exports = __webpack_public_path__ + "static/media/Honda.ce14bb62.svg";